module.exports = __webpack_public_path__ + "static/img/logo.dfd0ed6c.gif";